

<app-bread-crumb [Locations]="[{target : 'home', label : 'Home'}]" current="Water monitoring">
</app-bread-crumb>

<app-hero-banner  title="Water monitoring"></app-hero-banner>

<div class="nsw-container page-container">
	<div class="nsw-layout">
		<main class="nsw-layout__main">	

			<div class="nsw-docs__box nsw-docs__box--large">
				<div class="content">
					<h2>Water monitoring</h2>
					<p>
						Beachwatch and our partners monitor water quality at swim sites to ensure that recreational water environments are 
						managed as safely as possible so that as many people as possible can benefit from using the water.
					</p>

					<h3>Why we monitor</h3>
					<p>
						Our monitoring identifies safe and healthy waterways to meet community demand for information on swim sites throughout New South Wales. 
						Routine monitoring provides accurate information on the cleanliness of the water to help inform people about their risks and protect their health and wellbeing. 
						<br><br>
						Regular assessment plays an important role in detecting emerging pollution problems. 
						High-quality data enables effective stormwater and wastewater management and assessment, and highlights areas where further work is needed.
						<br><br>
						Beachwatch water quality monitoring provides transparency and ensures that guidelines are followed, 
						so councils and the community can feel confident that human health risks at swim sites are fully assessed.
					</p>

					<h3>Guidelines for managing risks in recreational waters</h3>
					<p>
						Our monitoring aligns with National Health and Medical Research Council (NHMRC) guidelines, which aim to protect people from 
						threats posed by the recreational use of coastal, estuarine and freshwater environments. 
						<app-external-link text="Visit the National Health and Medical Research Council (NHMRC)"
							[link]="NHMRC_PAGE_URL">
						</app-external-link> page to download.
					</p>
					<div class="nsw-callout" style="margin: 2.5rem 0rem;">
						<div class="nsw-callout__content">
							<h4 class="nsw-fh4">Confidence in our program</h4>
							<p>
								Our quality assurance program ensures that the information collected and reported by
								Beachwatch and our partners is accurate and reliable.
							</p>
							
							<a style="margin-top: 0.75rem;"
								href="https://www.environment.nsw.gov.au/publications/ensuring-confidence-beachwatch-water-quality-results"
								class="nsw-button nsw-button--dark" target="_blank">
								Check out the quality assurance factsheet
							</a>
						</div>
					</div>
				</div>


				<section class="nsw-section">
					<div class="nsw-container">
						<div class="nsw-layout">
							<div class="nsw-grid nsw-grid--spaced">
								<div class="nsw-col">
									<span class="nsw-section-title">
										<h2>You may also be interested in</h2>
									</span>
									<div class="nsw-grid">
										<div class="nsw-col nsw-col-md-6 nsw-col-lg-4">
											<app-content-card title="How we monitor"
												description="Find out how Beachwatch collects and tests water samples."
												[link]="['/waterMonitoring/howWeMonitor']" [isExternalLink]="false">
											</app-content-card>
										</div>
										<div class="nsw-col nsw-col-md-6 nsw-col-lg-4">
											<app-content-card title="How we report"
												description="Find out how Beachwatch and our partners check and report whether swim sites are clean enough for swimming."
												link="/waterMonitoring/howWeReport" [isExternalLink]="false">
											</app-content-card>
										</div>
										<div class="nsw-col nsw-col-md-6 nsw-col-lg-4">
											<app-content-card title="Explore our data"
												description="Data collected by Beachwatch and our partners can be viewed or downloaded."
												[link]="['/waterMonitoring/waterQualityData']"
												[isExternalLink]="false">
											</app-content-card>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

			</div>
			
		</main>
	</div>
</div>